import React from "react";
import "./ThankYouSlide.css";
import stageImage from "./stage.jpeg";

/**
 * ThankYouSlide
 * Recreation of the TEDxIITGuwahati "Thank You" slide.
 *
 * Removed from the original design:
 *  - Top-left "TEDxIITGuwahati" logo
 *  - Bottom row of social icons (Instagram, LinkedIn, YouTube, Mail)
 *
 * Everything else (background, colors, typography, layout, right-side
 * stage photo) is kept exactly the same.
 */
function ThankYouSlide() {
  return (
    <div className="tedx-slide">
      {/* Decorative red network/constellation graphics (kept as in original) */}
      <svg
          className="net net-top-left"
          viewBox="0 0 260 650"
          aria-hidden="true"
        >
          <g
            stroke="#b30e0e"
            strokeWidth="1.5"
            fill="none"
            opacity="0.7"
          >
            <line x1="15" y1="20" x2="170" y2="70" />
            <line x1="170" y1="70" x2="80" y2="180" />
            <line x1="80" y1="180" x2="210" y2="250" />
            <line x1="210" y1="250" x2="70" y2="340" />
            <line x1="70" y1="340" x2="190" y2="430" />
            <line x1="190" y1="430" x2="50" y2="540" />
            <line x1="50" y1="540" x2="160" y2="630" />

            <line x1="15" y1="20" x2="80" y2="180" />
            <line x1="170" y1="70" x2="210" y2="250" />
            <line x1="80" y1="180" x2="70" y2="340" />
            <line x1="210" y1="250" x2="190" y2="430" />
            <line x1="70" y1="340" x2="50" y2="540" />
            <line x1="190" y1="430" x2="160" y2="630" />

            <line x1="15" y1="20" x2="-40" y2="150" />
            <line x1="-40" y1="150" x2="70" y2="340" />
            <line x1="70" y1="340" x2="-35" y2="480" />
            <line x1="-35" y1="480" x2="50" y2="540" />
          </g>

          <g fill="#e01313">
            <circle cx="15" cy="20" r="3" />
            <circle cx="170" cy="70" r="3" />
            <circle cx="80" cy="180" r="3" />
            <circle cx="210" cy="250" r="3" />
            <circle cx="70" cy="340" r="3" />
            <circle cx="190" cy="430" r="3" />
            <circle cx="50" cy="540" r="3" />
            <circle cx="160" cy="630" r="3" />
          </g>
        </svg>

      {/* <svg className="net net-bottom-right" viewBox="0 0 200 200" aria-hidden="true">
        <g stroke="#b30e0e" strokeWidth="1" fill="none" opacity="0.8">
          <polygon points="60,20 100,10 140,35 150,80 120,120 70,120 40,80" />
          <line x1="60" y1="20" x2="100" y2="60" />
          <line x1="100" y1="10" x2="100" y2="60" />
          <line x1="140" y1="35" x2="100" y2="60" />
          <line x1="150" y1="80" x2="100" y2="60" />
          <line x1="120" y1="120" x2="100" y2="60" />
          <line x1="70" y1="120" x2="100" y2="60" />
          <line x1="40" y1="80" x2="100" y2="60" />
        </g>
        <g fill="#e01313">
          <circle cx="60" cy="20" r="2.5" />
          <circle cx="100" cy="10" r="2.5" />
          <circle cx="140" cy="35" r="2.5" />
          <circle cx="150" cy="80" r="2.5" />
          <circle cx="120" cy="120" r="2.5" />
          <circle cx="70" cy="120" r="2.5" />
          <circle cx="40" cy="80" r="2.5" />
          <circle cx="100" cy="60" r="3" />
        </g>
      </svg> */}

      {/* Top thin border line, kept from original */}
      {/* <div className="top-rule" /> */}

      <div className="content-wrapper">
        {/* Left column: text content (logo removed) */}
        <div className="left-column">
          <h1 className="thank-you">
            <span className="thank-white">THANK</span>
            <br />
            <span className="thank-red">YOU</span>
          </h1>

          <div className="divider-short" />

          <p className="body-text">
            Thank you for attending{" "}
            <span className="brand-red">TEDx</span>
            <span className="brand-white">IITGuwahati</span>!
          </p>
          <p className="body-text muted">
            Your presence truly adds meaning to the exchange of ideas, and we
            hope the talks have sparked new thoughts, inspired curiosity, and
            encouraged bold action.
          </p>

          <div className="divider-with-x">
            <span className="line" />
            <span className="x-mark">×</span>
            <span className="line" />
          </div>

          <p className="body-text muted">
            Together, we are shaping conversations worth spreading.
          </p>
          <p className="body-text bold">We look forward to seeing you again!</p>

          {/* Social icons row removed as requested */}
        </div>

        {/* Right column: stage photo (unchanged) */}
        <div className="right-column">
          <img
            src={stageImage}
            alt="TEDxIITGuwahati event stage"
            className="stage-image"
          />
        </div>
      </div>
    </div>
  );
}

export default ThankYouSlide;
